module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 67.6 67.6"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_4",
      "data-name": "Layer 4"
    }
  }, [_c('g', [_c('circle', {
    attrs: {
      "cx": "33.8",
      "cy": "33.8",
      "r": "33.8",
      "fill": "#2baae2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M55.65,19.49a2.12,2.12,0,0,0-1-.25H13a2.13,2.13,0,0,0-2.13,2.13V46.23A2.15,2.15,0,0,0,13,48.37h41.7a2.16,2.16,0,0,0,2.14-2.14V21.37A2.13,2.13,0,0,0,55.65,19.49ZM54.47,44.41a1.49,1.49,0,1,1-1.81,2.36L38.49,35.87l-2.56,2a3.55,3.55,0,0,1-4.26,0l-2.56-2L14.94,46.77a1.48,1.48,0,0,1-2.08-.27,1.49,1.49,0,0,1,.27-2.09L26.68,34,13.13,23.59a1.49,1.49,0,0,1,1.81-2.36L30.05,32.84l3.44,2.64a.52.52,0,0,0,.63,0L52.66,21.23a1.49,1.49,0,0,1,1.81,2.36L40.93,34Z",
      "fill": "#fff"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98a87eb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/SubmittedIcon.vue
// module id = 3322
// module chunks = 0